/*
 * Packages split view (js/components/packages-split-view.js).
 *
 * Level 2 progressive enhancement for the H&L listings map view: cards grid
 * on the left, sticky map panel on the right, and a "Hide Map" toggle in the
 * listing toolbar that collapses the panel so the cards run full-width.
 * Server-first: the cards render complete without JS; the map panel and the
 * toggle are js-only, so a no-JS visit simply gets the full-width grid.
 *
 * Alpine CSP build — bindings are named methods / property reads only.
 */
export default function packagesSplitView() {
    return {
        // Map shown by default; the toggle hides it. Shared by the display-home
        // and package listings.
        showMap: true,

        toggleMap() {
            this.showMap = !this.showMap;
        },

        get rootClasses() {
            return this.showMap ? 'mh-listings-split--with-map' : 'mh-listings-split--map-hidden';
        },

        get toggleLabel() {
            return this.showMap ? 'Hide Map' : 'View Map';
        },

        get togglePressed() {
            return this.showMap ? 'true' : 'false';
        },
    };
}
